import React from "react";
import logo from "../../images/TDCX_Logo.png";

const TDCXLogo = ({
  width = 200,
  height,
  alt = "TDCX Logo",
  ...props
}) => {
  const aspectRatio = 930 / 303;
  if (width && !height) {
    height = width / aspectRatio;
  }
  return (
    <img
      src={logo}
      width={width}
      height={height}
      alt={alt}
      style={{ display: "block" }}
      {...props}
    />
  );
};

export default TDCXLogo;
